/* lua.js generated code 0.3.0 */

Quality = table.const(table(
    [1, "kFPSGuardLine", 50],
    [1, "kBossModeFPSGuardLine", 40],
    [1, "kScoreStarMaxNum", 20],
    [1, "kScoreParticleMaxNum", 50],
    [1, "kLineEffectMaxNum", 4]
))
